import styled from "styled-components";

type ContentType = {
    background: string;
    border: string;
};

type ContainerType = {
    heightShowingHeaderInfo: number;
};

type IconOpsType = {
    color: string;
}

export const Container = styled.div<ContainerType>`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 16px;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 111px - ${props => `${props.heightShowingHeaderInfo}px`});
  overflow: hidden;
`;
export const TextError = styled.span<IconOpsType>`
  font-size: 12px;
  color: ${props => props.color};
  padding: 0 0 0 3px;
`;
export const Content = styled.div<ContentType>`
  display: flex;
  flex-direction: column;
  background: ${props => props.background};
  flex: 1;
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid ${props => props.border};
`;
export const ContainerPermission = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  flex: 1;
  overflow: hidden;
  min-width: 768px;
  width: 768px;
`;
export const ContentPermission = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 40px;
  min-height: 40px;
`;
export const TextPermission = styled.span<IconOpsType>`
  font-size: 16px;
  color: ${props => props.color};
  font-weight: bold;
  cursor: pointer;
  padding-left: 10px;

  &:hover {
    filter: brightness(80%);
  }
`;
export const ContentSelectSearchLimitMinutes = styled.div`
  display: flex;
  flex-direction: row;
  width: 300px;
  padding-left: 10px;
`;
